
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/duo/invite/[token]",
      function () {
        return require("private-next-pages/duo/invite/[token]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/duo/invite/[token]"])
      });
    }
  